import { api } from "../config/axiosConfig";

export const fetchUserRequest = (userId: number) => {
    const requestURL = `/v1/athletes/${userId}`;
    return api().get(requestURL);
};